<template>
	<tr>
		<td><strong>{{week.name}}</strong></td>
		<td>{{weekStartTime}} - {{weekEndTime}}</td>
	</tr>
</template>


<script>
import moment from 'moment';
export default {
	name: 'CampWeek',
	data: function() {
		return {};
	},

	props: ['week'],

	computed: {
		day: function() {
			// return moment.utc(this.run.runStartTime * 1000).format('ddd');
		},
		weekStartTime: function() {
			return moment
				.utc(this.week.weekStart * 1000)
				.format('ddd Do MMMM YYYY');
		},
		weekEndTime: function() {
			return moment
				.utc(this.week.weekEnd * 1000)
				.format('ddd Do MMMM YYYY');
		}
	},

	mounted: function() {}
};
</script>

<style scoped>
</style>
